import { useMemo } from "react";
import { ToastContainer } from "react-bootstrap";
import CustomDatePicker from "../../Common/DatePicker";
import Select from "react-select";
import { MultiSelect } from "react-multi-select-component";

const FilterBar = ({
  filters,
  filterDate,
  setFilterDate,
  selectedFilters,
  setSelectedFilters,
  isLoading,
  dashboardChartData
}) => {
  const filter1Values = useMemo(() => {
    if (filters) {
      return Object.keys(filters).map((x) => ({
        value: x,
        label: x
          .split("_")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
      }));
    }
  }, [filters]);
  
  const filter2Values = useMemo(() => {
    if (filter1Values.length > 0 && selectedFilters["filter1"]) {
      return Object.keys(filters[filter1Values[0].value])
        .sort()
        .map((x) => ({
          value: x,
          label: x
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" "),
        }));
    }
    return [];
  }, [filters, filter1Values]);
  const filter3Values = useMemo(() => {
    if (filter2Values.length > 0 && selectedFilters["filter2"].length > 0) {
      return Object.keys(
        filters[selectedFilters["filter1"].value][
          selectedFilters["filter2"][0].value
        ]
      )
        .sort()
        .map((x) => ({
          value: x,
          label: x
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" "),
        }));
    }
    return [];
  }, [selectedFilters]);

  const handleFilter1Change = (value) => {
    setSelectedFilters({
      ...selectedFilters,
      filter1: value,
    });
  };
  const customValueRenderer = (selected, _options) => {
    if (_options.length === 0) {
      return "No options available";
    } else if (selected.length === _options.length) {
      return "All Keywords/Companies";
    } else if (selected.length === 0) {
      return "No Keyword/ Company";
    } else if (selected.length === 1) {
      return selected.map(({ label }) => label);
    } else {
      return selected.map(({ label }) => label).join(", ");
    }
  };

  const handleFilter2Change = (value) => {
    setSelectedFilters({
      ...selectedFilters,
      filter2: [value],
      filter3: [filter3Values[0]],
    });
  };
  const handleFilter3Change = (value) => {
    setSelectedFilters({ ...selectedFilters, filter3: value });
  };

  return (
    <div>
      <>
        <ToastContainer />
        <div className="row mb-4 ">
          <div className="col-md-3 col-4">
            <CustomDatePicker
              setDateFilter={setFilterDate}
              filterDate={filterDate}
              isLoading={isLoading}
            />
          </div>
         { dashboardChartData === null ?null:<>
         
          <div className="col-2">
            <Select
              options={filter2Values}
              value={selectedFilters["filter2"]?.[0] || null}
              onChange={handleFilter2Change}
              labelledBy={"Select Countries"}
              className="multi-select"
              isDisabled={isLoading}
            />
          </div>
          {filter1Values.length > 1 && (
            <div className="col-2">
              <Select
                value={selectedFilters["filter1"]}
                options={filter1Values}
                onChange={handleFilter1Change}
                className="basic-single"
                classNamePrefix="select"
                isSearchable={true}
                name="category"
                placeholder="Select Category"
                disabled={isLoading}
              />
            </div>
          )}

          <div className=" col-2 ">
            <MultiSelect
              options={filter3Values}
              value={selectedFilters["filter3"] || []}
              onChange={handleFilter3Change}
              labelledBy={"Select Companies"}
              className="multi-select"
              disabled={isLoading}
              valueRenderer={customValueRenderer}
            />
          </div>
         </>}
          
        </div>
      </>
    </div>
  );
};

export default FilterBar;
